(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-mosaic"] && !Shopify.designMode) return;
  try {
    
function initMosaicSwiper(){
  document.querySelectorAll('.category-scroller').forEach(slider=>{
    if(!slider.classList.contains('swiper-initialized')){
      new Swiper(slider,{
        slidesPerView: 2,
        spaceBetween: 20,
        grabCursor: true,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
        keyboard: { enabled: true, onlyInViewport: true },
        simulateTouch: true,
        touchStartPreventDefault: false,
        passiveListeners: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          992: { slidesPerView: 2 }
        }
      });
    }
  });
}
document.addEventListener('DOMContentLoaded', initMosaicSwiper);
document.addEventListener('shopify:section:load', initMosaicSwiper);
document.addEventListener('shopify:section:reorder', initMosaicSwiper);

  } catch(e) { console.error(e); }
})();
})();
